import { render, staticRenderFns } from "./DetalhesCompraDiretaAcoes.vue?vue&type=template&id=b9503b76&scoped=true"
import script from "./DetalhesCompraDiretaAcoes.vue?vue&type=script&lang=js"
export * from "./DetalhesCompraDiretaAcoes.vue?vue&type=script&lang=js"
import style0 from "./DetalhesCompraDiretaAcoes.vue?vue&type=style&index=0&id=b9503b76&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9503b76",
  null
  
)

export default component.exports